/** @format */

const data = [
	{
		id: 1,
		imagePath: require("../assets/moneys.png"),
		amount: 175,
		user: "Standard User",
	},
	{
		id: 2,
		imagePath: require("../assets/people.png"),
		amount: "2,500",
		user: "Premium User",
	},
];

export default data;
